export default "__VITE_ASSET__e3699361__"